import { makeRequest } from '@/graphs/index';
import { benevityCauseEligibility } from '@/graphs/gql';

export interface BenevityCauseEligibilityResult {
  causeId: string;
  typeCode: string;
  isDonatable: boolean;
  reason: string;
}

export async function checkBenevityCauseEligibility(
  causeId: string,
  token: string,
): Promise<BenevityCauseEligibilityResult | null> {
  try {
    const response = await makeRequest(
      'query',
      benevityCauseEligibility,
      { causeId },
      { token },
    );

    if (response?.errors) {
      console.error('[checkBenevityCauseEligibility] errors:', response.errors);
      return null;
    }

    return response.data?.benevityCauseEligibility ?? null;
  } catch (error) {
    console.error('[checkBenevityCauseEligibility] exception:', error);
    return null;
  }
}
